module.exports = __webpack_public_path__ + "img/paper01.728de0ae.jpeg";